import { Icon } from '@/components/Icon/Icon';
import {
  IconsTrack,
  PendingProfileContainer,
  ScrollingIcons,
} from '@/components/Layout/Page/Page.styled';

export function PendingApproval() {
  return (
    <PendingProfileContainer>
      <ScrollingIcons>
        <IconsTrack>
          <Icon name="document-transparent" size={60} />
          <Icon name="document" size={80} />
          <Icon name="document-transparent" size={60} />
          <Icon name="document-transparent" size={60} />
          <Icon name="document" size={80} />
          <Icon name="document-transparent" size={60} />
        </IconsTrack>
      </ScrollingIcons>
    </PendingProfileContainer>
  );
}
